import { RmxArrowBackIcon } from 'cokitchen-icons';
import FeedCard from 'components/feed-card';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { numberWithCommas } from 'utils/functions';
import { MealType } from 'utils/types';
import { ReactComponent as EditMealIcon } from 'assets/icons/edit-meal-icon.svg';
import { ReactComponent as DeleteMealIcon } from 'assets/icons/delete-meal-icon.svg';
import { ReactComponent as DuplicateMealIcon } from 'assets/icons/duplicate-meal-icon.svg';
import { ReactComponent as ConvertMealIcon } from 'assets/icons/convert-meal-icon.svg';
import MealDropdownOptions, { MealDropdownOptionType } from 'components/meal-dropdown-options';
import { ROUTE_PREFIX } from 'utils/constants';

const MealsByBaseAddonCategory = () => {
  const [meals, setMeals] = useState<MealType[]>();
  const [loading, setLoading] = useState(false);
  const [activeMeal, setActiveMeal] = useState<MealType>();
  const [showDeleteMealModal, setshowDeleteMealModal] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    getMeals();
  }, [id]);

  const getMeals = async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`marketing/addon-category/base/${id}`);
      setMeals(res.data.data);
    } catch {
      console.log('error');
    } finally {
      setLoading(false);
    }
  };

  const deleteMeal = () => {
    setshowDeleteMealModal(!showDeleteMealModal);
  };
  const editMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/edit-meal/${activeMeal?.id}`);
  };
  const convertMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/convert-meal-to-addon/${activeMeal?.id}`, {
      state: activeMeal?.name
    });
  };
  const duplicateMeal = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/duplicate-meal/${activeMeal?.id}`, {
      state: activeMeal?.name
    });
  };
  const dropdownList: MealDropdownOptionType[] = [
    {
      name: 'Edit meal',
      icon: <EditMealIcon className='w-4 h-4' />,
      onClick: editMeal
    },
    {
      name: 'Duplicate meal',
      icon: <DuplicateMealIcon className='w-4 h-4' />,
      onClick: duplicateMeal
    },
    {
      name: 'Convert meal',
      icon: <ConvertMealIcon className='w-4 h-4' />,
      onClick: convertMeal
    },
    {
      name: 'Archive meal',
      icon: <DeleteMealIcon className='w-4 h-4 text-red-5' />,
      className: 'text-red-5',
      onClick: deleteMeal
    }
  ];

  return (
    <div>
      {loading ? (
        <p className='text-sm flex justify-center items-center mt-7'> loading ...</p>
      ) : meals?.length === 0 ? (
        <p className='text-sm flex justify-center items-center mt-7'>No meals found</p>
      ) : (
        <div className='grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-3 mt-4'>
          {meals?.map((meal) => (
            <div key={meal.id}>
              <FeedCard
                className='w-full'
                image={meal.images[0]}
                actions={
                  <MealDropdownOptions
                    onClick={() => setActiveMeal(meal)}
                    dropdownList={dropdownList}
                  />
                }>
                <div className='flex justify-between items-center mt-2'>
                  <div>
                    <p className='text-sm'>{meal?.base_meal?.name}</p>
                    <p className='text-xs text-gray-5'>&#8358;{numberWithCommas(meal.amount)}</p>
                  </div>
                  <RmxArrowBackIcon className='transform rotate-180 w-[20px] h-[20px] text-[#B6AFAF]' />
                </div>
              </FeedCard>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MealsByBaseAddonCategory;
